import { Company } from './company';
import { api } from './store';
import { BasePermissions } from './permission';

/* INTERFACES */
export interface Ownership {
  id: string;
  $permissions: BasePermissions[];
  role?: string;
  company: Company;
}

/* OWNERSHIPS CREATE */
export async function createOwnership({
  productId,
  role,
  companyId,
}: {
  productId: string;
  role?: string;
  companyId?: string;
}): Promise<void> {
  await api.createOwnership({ productId, role, companyId });
}

/* OWNERSHIPS DELETE */
export async function deleteOwnership({ ownershipId }: { ownershipId: string }): Promise<void> {
  await api.destroyOwnership({ ownershipId });
}
